// extracted by css-extract-rspack-plugin
export default {"cls1":"AddToListButton-cls1_f_Z","cls2":"AddToListButton-cls2_0sa AddToListButton-cls1_f_Z"};